import './DisclaimerText.scss';
import {Typography} from '@mui/material';

const DisclaimerText = () => (
  <Typography variant="caption" className="DisclaimerText" data-testid="DisclaimerText">
    <span className="asterisk">*</span>
    This data point was edited by the author of this CMA and has not been verified by Cotality
  </Typography>
);

DisclaimerText.propTypes = {};

DisclaimerText.defaultProps = {};

export default DisclaimerText;
